import React from 'react'
import Tag from 'tag'

const Skills = React.createClass({
	render() {
		return (

			<div>
				<div className="wrapper">

					<section id="skills" className="full-width pad-section">

						<h2>What I Know</h2>

						<div id="tags">
							<Tag size="6" name="Javascript ES5" />
							<Tag size="3" name="Javascript ES6" />
							<Tag size="5" name="React JS" />
							<Tag size="6" name="JSX" />
							<Tag size="4" name="Flux" />
							<Tag size="6" name="AJAX" />
							<Tag size="6" name="JSON" />
							<Tag size="4" name="RESTful" />
							<Tag size="3" name="SQL" />
							<Tag size="2" name="NoSQL" />
							<Tag size="4" name="Angular JS" />
							<Tag size="5" name="jQuery" />
							<Tag size="6" name="HTML5" />
							<Tag size="6" name="CSS3" />
							<Tag size="5" name="Sass (SCSS)" />
							<Tag size="5" name="Less" />
							<Tag size="6" name="Wordpress" />
							<Tag size="4" name="PHP" />
							<Tag size="2" name="Java" />
							<Tag size="1" name="ASP" />
							<Tag size="1" name="Swift" />
							<Tag size="2" name="Objective C" />
							<Tag size="5" name="Node/NPM" />
							<Tag size="1" name="Grunt" />
							<Tag size="5" name="Gulp" />
							<Tag size="2" name="Webpack" />
							<Tag size="3" name="Git" />
							<Tag size="4" name="Perforce" />
							<Tag size="4" name="Eclipse" />
							<Tag size="6" name="Sublime Text" />
							<Tag size="3" name="Websphere" />
							<Tag size="2" name="Unix" />
							<Tag size="3" name="Terminal" />
							<Tag size="6" name="Photoshop" />
							<Tag size="6" name="Illustrator" />
							<Tag size="2" name="Flash" />
							<Tag size="1" name="Indesign" />
							<Tag size="3" name="Print Design" />
							<Tag size="5" name="Sketch" />
							<Tag size="5" name="UX" />
							<Tag size="6" name="UI" />
							<Tag size="3" name="Unity" />
							<Tag size="2" name="AS3" />
							<Tag size="1" name="Citrus Engine" />
							<Tag size="2" name="Coherent UI" />
							<Tag size="3" name="SEO" />
							<Tag size="2" name="SEM" />
							<Tag size="3" name="Socket.io" />
							<Tag size="4" name="Responsive" />
						</div>


					</section>

					<hr />

				</div>

			</div>

		)
	}
});

module.exports = Skills;